<div class="d-flex justify-content-between" [class.flex-column]="mobileSizeService.isMobileSize" [class.overflow-y-auto]="mobileSizeService.isMobileSize">
  <div *ngFor="let item of items">
    <app-content-block [item]="item" (userSelected)="userSelectedContentBlock($event)"
                       [selectedImageIndex]="selectedImageIndex"
                       (selectedImageIndexChange)="onSelectedIamgeIndexChange($event)"
                        [(scrollLeft)]="scrollLeft"
    ></app-content-block>
  </div>
</div>
